module.exports = __webpack_public_path__ + "img/87.af9ea62e.jpg";